'use strict';

import { colors } from '@hydra/common/styles';

export const scoreValuesDefinitions = {
  success: {
    color: colors.success.main,
    minScoreValue: 70
  },
  warning: {
    color: colors.warning.main,
    minScoreValue: 50
  },
  error: {
    color: colors.error.main,
    minScoreValue: 10
  },
  grey: {
    color: colors.grey[400],
    minScoreValue: 0
  }
};

export const scoreValues = [
  { ...scoreValuesDefinitions.success },
  { ...scoreValuesDefinitions.warning },
  { ...scoreValuesDefinitions.error },
  { ...scoreValuesDefinitions.grey }
];

const scoreToColorCode = (score) => {
  const { success, warning, error, grey } = scoreValuesDefinitions;

  if (score >= success.minScoreValue) {
    return success.color;
  } else if (score >= warning.minScoreValue) {
    return warning.color;
  } else if (score >= error.minScoreValue) {
    return error.color;
  } else {
    return grey.color;
  }
};

export default scoreToColorCode;
